import React from "react";
import classNames from "classnames";
import Link, { LinkProps } from "next/link";

import IconSvg from "@/components/IconSvg";

type Props = {
  count?: number;
  disabled?: boolean;
  iconPath: string | null;
  label: string;
  lowercase?: boolean;
  showCount?: boolean;
  selected?: boolean;
  rel?: string;
} & LinkProps &
  React.HTMLAttributes<HTMLAnchorElement>;

const DisableableLink = ({
  disabled,
  children,
  selected,
  className,
  ...linkProps
}: LinkProps & {
  disabled?: boolean;
  selected?: boolean;
  children: React.ReactNode;
  className?: string;
}) => {
  if (disabled) {
    return (
      <div
        className={classNames(
          "flex flex-col items-center border-2 text-xs py-sm w-full rounded overflow-hidden",
          {
            "border-light-grey": !selected,
            "cursor-default": disabled,
            "cursor-pointer": !disabled,
            "opacity-50": disabled,
          },
          className,
        )}
      >
        {children}
      </div>
    );
  } else {
    return (
      <Link
        {...linkProps}
        className={classNames(
          "flex flex-col items-center border-2 text-xs py-sm w-full rounded overflow-hidden",
          {
            "border-light-grey": !selected,
            "cursor-default": disabled,
            "cursor-pointer": !disabled,
            "opacity-50": disabled,
          },
          className,
        )}
      >
        {children}
      </Link>
    );
  }
};

/**
 * A button interface that's suited for use in filter interface with a small
 * number of options (e.g. strain type, effects, etc.).
 */
const TileLink = ({
  className,
  count = 0,
  disabled = false,
  iconPath,
  label,
  showCount = true,
  lowercase,
  selected,
  ...props
}: Props) => {
  return (
    <DisableableLink
      selected={selected}
      disabled={disabled}
      className={className}
      {...props}
    >
      {iconPath ? (
        <IconSvg
          height="24"
          width="24"
          className="block mb-xs"
          filePath={iconPath}
        />
      ) : null}

      <div
        className={classNames("font-bold leading-none mb-xs truncate", {
          capitalize: !lowercase,
          lowercase,
        })}
      >
        {label}
      </div>
      {showCount && (
        <div className={classNames("leading-none text-grey")}>
          ({count.toLocaleString("en-us")})
        </div>
      )}
    </DisableableLink>
  );
};

export default TileLink;
